import { useState } from "react";
import "./pet.css";
import Saludando from "./assets/buho-saludando.png";
import Pensando from "./assets/buho-pensando.png";
import Escribiendo from "./assets/buho-escribiendo.png";
import Listo from "./assets/buho-listo.png";
import Chatbot from "./chatbot";

export default function OwlFAB() {
  const [chatOpen, setChatOpen] = useState(false);
  const [estado, setEstado] = useState("saludando");

  const sprites = {
    saludando: Saludando,
    pensando: Pensando,
    escribiendo: Escribiendo,
    listo: Listo,
  };

  const sprite = sprites[estado] || Saludando;

  const handleChatClose = () => {
    setChatOpen(false);
    setEstado("saludando");
  };

  return (
    <>
      <div 
        className="pet-fab" 
        onClick={() => setChatOpen(true)} 
        role="button" 
        aria-label="Abrir chat de ayuda"
      >
        <div className="pet-pill">
          <div className="pet-bubble">
            <div className="pet-dots">
              <span /><span /><span />
            </div>
          </div>
          <div className="pet-text">
            <span className="pet-title">¿Necesitas ayuda?</span>
            <span className="pet-sub">Estoy aquí para ayudarte</span>
          </div>
        </div>
        <img className="pet-owl" src={sprite} alt="búho" />
      </div>

      <Chatbot open={chatOpen} onClose={handleChatClose} estado={estado} />
    </>
  );
}